import React, { useState } from "react";
import { connect } from "react-redux";
import { format, subYears } from "date-fns";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  Typography,
} from "@mui/material";

import {
  advancedSearch,
  clearSearchResult,
  clearSelectedProfile,
  sendInterest,
  updateProfile,
} from "../store/actions";

import { AGE, CASTE, GENDER, RELIGION } from "../helpers/dbFields";
import ProfileDetails from "./Shared/ProfileDetails";
import ProfileList from "./Profile/ProfileList";

const AdvancedSearch = (props) => {
  const { profile, user } = props;

  const [selectedGender, setSelectedGender] = useState(
    profile.gender === "MALE" ? "FEMALE" : "MALE"
  );
  const [selectedAge1, setSelectedAge1] = useState("18");
  const [selectedAge2, setSelectedAge2] = useState("30");
  const [selectedReligion, setSelectedReligion] = useState("HINDU");
  const [selectedCaste, setSelectedCaste] = useState("ANY");
  const [vnkId, setVnkId] = useState("");

  const handleSearch = () => {
    debugger;
    props.advancedSearch({
      gender: selectedGender,
      religion: selectedReligion,
      caste: selectedCaste,
      dob1: subYears(new Date(), parseInt(selectedAge1, 10)),
      dob2: subYears(new Date(), parseInt(selectedAge2, 10)),
      vnkId: vnkId.trim() || null,
    });
  };

  const handleSendInterest = (uid) => {
    const interests = Array.isArray(profile.interests) ? profile.interests : [];
    const interest = {
      date: new Date(),
      senderUid: user.uid,
      receiverUid: uid,
    };
    interests.push(interest);
    props.updateProfile(user, profile, { interests });
    props.sendInterest(uid, user.uid, interest);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {(!props.profiles && !props.selectedProfile) && (
        <Box
          sx={{
            bgcolor: "background.paper",
            p: { xs: 2.5, sm: 4 },
            borderRadius: "20px",
            border: "1px solid var(--border)",
            boxShadow: "var(--shadow)",
          }}
        >
          <Typography variant="h5" align="center" mb={3}>
            Advanced Search
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Looking for a</InputLabel>
                <Select
                  value={selectedGender}
                  label="Looking for a"
                  onChange={(e) => setSelectedGender(e.target.value)}
                >
                  {Object.keys(GENDER).map(
                    (key) =>
                      key !== profile.gender && (
                        <MenuItem key={key} value={key}>
                          {GENDER[key]}
                        </MenuItem>
                      )
                  )}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
              <FormControl fullWidth>
                <InputLabel>Age From</InputLabel>
                <Select
                  value={selectedAge1}
                  label="Age From"
                  onChange={(e) => setSelectedAge1(e.target.value)}
                >
                  {Object.keys(AGE).map((key) => (
                    <MenuItem key={key} value={key}>
                      {AGE[key]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={3} md={2}>
              <FormControl fullWidth>
                <InputLabel>To</InputLabel>
                <Select
                  value={selectedAge2}
                  label="To"
                  onChange={(e) => setSelectedAge2(e.target.value)}
                >
                  {Object.keys(AGE).map((key) => (
                    <MenuItem key={key} value={key}>
                      {AGE[key]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Religion</InputLabel>
                <Select
                  value={selectedReligion}
                  label="Religion"
                  onChange={(e) => setSelectedReligion(e.target.value)}
                >
                  {Object.keys(RELIGION).map((key) => (
                    <MenuItem key={key} value={key}>
                      {RELIGION[key]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Caste</InputLabel>
                <Select
                  value={selectedCaste}
                  label="Caste"
                  onChange={(e) => setSelectedCaste(e.target.value)}
                >
                  {Object.keys(CASTE[selectedReligion]).map((key) => (
                    <MenuItem key={key} value={key}>
                      {CASTE[selectedReligion][key]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="VNK ID (optional)"
                value={vnkId}
                onChange={(e) => setVnkId(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <Box textAlign="center">
                <Button
                  variant="contained"
                  size="large"
                  sx={{ px: 5 }}
                  onClick={handleSearch}
                >
                  Search
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}

      {props.profiles && !props.selectedProfile && (
        <Box mt={4}>
          <Button onClick={props.clearSearchResult} sx={{ mb: 2 }}>
            Modify Search
          </Button>
          <ProfileList />
        </Box>
      )}

      {props.selectedProfile && (
        <Box mt={4}>
          <Button onClick={props.clearSelectedProfile} sx={{ mb: 2 }}>
            Back to Search Results
          </Button>
          <Button
            variant="outlined"
            sx={{ mb: 2, ml: 2 }}
            onClick={() => handleSendInterest(props.selectedProfile.uid)}
          >
            Send Interest
          </Button>
          <ProfileDetails
            props={{
              profile: props.selectedProfile,
              profileContacts: props.setSelectedProfileContacts,
              me: props.profile,
            }}
          />
        </Box>
      )}
    </Box>
  );
};

const mapDispatchToProps = (dispatch) => ({
  advancedSearch: (selections) => dispatch(advancedSearch(selections)),
  clearSelectedProfile: () => dispatch(clearSelectedProfile()),
  clearSearchResult: () => dispatch(clearSearchResult()),
  sendInterest: (uid, myUid, interests) =>
    dispatch(sendInterest(uid, myUid, interests)),
  updateProfile: (user, profile, interests) =>
    dispatch(updateProfile(user, profile, interests)),
});

const mapStateToProps = (state) => ({
  profile: state.profileState.profile,
  profiles: state.profileState.searchResults,
  selectedProfile: state.profileState.selectedProfile,
  setSelectedProfileContacts: state.profileState.setSelectedProfileContacts,
  user: state.userState.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSearch);
